export const CONSTANTS = {
  API: {
    ADMIN: {
      COMPANY_SUMMARY: "/api/Admin/CompanySummary",
      AUDIT_LOGS: "/api/Admin/AuditLogs",
      DOWNLOAD_LOGS: "/api/Admin/DownloadLogs",
      LOGIN_LOGS: "/api/Admin/LoginLogs",
    },
    ACCESS_SUMMARY: {
      REPORT: "/api/Admin/ReportAccess",
      DOCUMENT: "/api/Admin/DocumentAccessList",
      VESSELS_TRACKING: "/api/Admin/VesselTrackingAccess",
      PASSAGE_REPORT: "/api/Admin/PassageReportAccess",
    },
    ACCOUNT: {
      LOGIN: "/api/user/login",
      LOGOUT: "/api/account/logout",
      CHANGE_EMAIL: "/api/profile",
      FORGOT_PASSWORD_API: "/api/user/forgot-password",
      USER_INFOR: "/api/profile",
      PERMISSION: "/api/user/permission",
      VERIFYTOKEN: "/api/user/reset-password-token-validation",
      CHANGE_PASSWORD_LINK_API: "/api/user/reset-password-email-link",
      VALIDATE_FORGOT_PASSWORD_API: "/api/user/validate-forgot-password",
    },
    RESEARCH: {
      RESEARCH_REPORTS: "/api/research-document",
      IN_HOUSE: "/api/research-document",
      DOCUMENT: "/api/log/download/research",
    },
    COMMON: {
      POOL: "/api/pool",
      POOL_V2: "/api/pool/v2",
      ENTITLED_POOLS: "/api/pool",
      POOL_FLEET: "/api/vessel/fleet",
    },
    EARNING: {
      LATEST_AVERAGE_POOL_EARNING: "/api/Earnings/LatestAveragePoolEarnings",
      LATEST_AVERAGE_POOL_EARNING_V2: "/api/vessel-tce",
      GET_POOL_EARNINGS_BREAKDOWN: "/api/Earnings/PoolEarningsBreakdown",
      VOYAGE_PN_LS: "/api/Earnings/VoyagePnLs",
      VOYAGE_PN_LS_V2: "/api/voyage-pnl",
      VOYAGE_PNL_VESSELS: "/api/voyage-pnl/v2/vessel",
    },

    PASSAGE: {
      GET_PASSAGE_REPORT: "/api/Passage/Reports",
    },
    REPORT: {
      CATEGORY: "/api/reportcategory",
      REPORT: "/api/report/get",
      MID_MONTHLY_DISTRIBUTION: "/api/report/get",
      QUARTERLY: "/api/report/get",
      MONTHLY_DISTRIBUTION: "/api/report/get",
      MONTHLY_COMMENTARY: "/api/report/get",
      WEEK_OUTLOOK: "/api/report/get",
      DOCUMENT: "/api/log/download/report",
    },
    MARKET: {
      MARKET_UPDATE: "/api/commentary",
      MARKET_UPDATE_GET: "/api/commentary/get-commentary",
      DETAIL_COMMENTARY: "/api/commentary/get-detail-by-id",
    },
    DOWNLOAD: {
      REPORT: "/api/Download/Report",
      DOCUMENT: "/api/Download/Document",
      SHIP_DOCUMENT: "/api/Download/ShipDocument",
      PASSAGE_REPORT: "/api/Download/PassageReport",
      RE_SEARCH: "/api/log/download/research",
      THUMBNAIL: "/api/Download/Thumbnail",
    },
    DOCUMENT: {
      POOL_POINTS_EVALUATION_PROCESS: "/api/document",
      FINANCIAL_STATEMENTS: "/api/document",
      PRESENTATIONS: "/api/document",
      OPS_CIRCULARS: "/api/document",
      OTHERS: "/api/document",
      LEGAL_UPDATES: "/api/Document/LegalUpdates",
      DOCUMENT: "/api/log/download/document",
    },
    SHIP_DOCUMENT: {
      SHIP_DOCUMENTS: "/api/ShipDocument/ShipDocuments",
    },
    VESSEL: {
      VESSELS: "/api/Vessel/Vessels",
      TRACKING: "/api/Vessel/Tracking",
      V2: {
        VESSELS: "/api/vessel",
        VESSEL_IMO: "/api/vessel/imo?imo=",
        VESSEL: "/v2/vessel",
      },
    },
    COMPANY: {
      GET_ALL: "/api/Admin/CompanyList",
      DISABLE: "/api/Admin/DisableCompany",
      ENABLE: "/api/Admin/EnableCompany",
      ADD: "/api/Admin/Company",
    },
    USER: {
      GET_ALL: "/api/Admin/UserList",
      DISABLE: "/api/Admin/DisableUser",
      ENABLE: "/api/Admin/EnableUser",
      REGISTER: "/api/Admin/RegisterUser",
      EDIT: "/api/Admin/User",
    },
    Report_Access: {
      GET_ALL: "/api/Admin/ReportAccess",
      REMOVE: "/api/Admin/ReportAccess",
      EDIT: "/api/Admin/ReportAccess",
    },
    Vessel_Tracking_Access: {
      GET_ALL: "/api/Admin/VesselTrackingAccess",
      GRANT: "/api/Admin/VesselTrackingAccess",
      DISABLE: "/api/Admin/VesselTrackingAccess",
    },
    PassageReportAccess: {
      GET_ALL: "/api/Admin/PassageReportAccess",
      EDIT: "/api/Admin/PassageReportAccess",
      REMOVE: "/api/Admin/PassageReportAccess",
    },
    PassageReportReview: {
      GET_ALL: "/api/Admin/PassageReportReview",
      EDIT: "/api/Admin/PassageReportReview",
      DELETE: "/api/Admin/PassageReportReview",
    },
    ReportManager: {
      Get_Weekly: "/api/Report/Weekly",
      Get_MidMonthDistribution: "/api/Report/MidMonthDistribution",
      Get_Quarterly: "/api/Report/Quarterly",
      Get_MonthlyDistribution: "/api/Admin/MonthlyDistribution",
      Get_MonthlyCommentary: "/api/Report/MonthlyCommentary",
      UPLOAD: "/api/Admin/Report",
      EDIT: "/api/Admin/Report",
      DELETE: "/api/Admin/Report",
    },
    DocumentManager: {
      GET_ALL: "/api/Admin/DocumentAccessList",
      CREATE: "/api/Admin/Document",
      EDIT: "/api/Admin/Document",
      DELETE: "/api/Admin/Document",
    },
    AccessSummary: {
      Report: "/api/Admin/ReportAccessSummary",
      Document: "/api/Admin/DocumentAccessSummary",
      VesselTracking: "/api/Admin/VesselTrackingAccessSummary",
      PassageReport: "/api/Admin/PassageReportAccessSummary",
    },
    WORK_SHOP: {
      LIST: "/api/webinar",
    },
  },
  TOKEN_KEY: "TOKEN_KEY",
};
